import alertMessageBox from './alertMessageBox.vue';    
import confirmMessageBox from './confirmMessageBox.vue';    
import infoMessageBox from './infoMessageBox.vue';    
// 定义插件对象
const MessageBox = {};
// vue的install方法，用于定义vue插件
MessageBox.install = function (Vue, options) {
    //alert弹框
    const alertMessageBoxInstance = Vue.extend(alertMessageBox);
    let alertMessage;
    //确定弹框
    const confirmMessageBoxInstance = Vue.extend(confirmMessageBox);
    let confirmMessage;
    //信息弹框
    const infoMessageBoxInstance = Vue.extend(infoMessageBox);
    let infoMessage;
    
    // 初始化注入
    const initInstance = (name) => {
      // 实例化vue实例
      if(name=='alertMessage'){
        alertMessage = new alertMessageBoxInstance();
      }
      if(name=='confirmMessage'){
        confirmMessage = new confirmMessageBoxInstance();
      }
      if(name=='infoMessage'){
        infoMessage = new infoMessageBoxInstance();
      }
    };
    //在Vue的原型上添加实例方法，以全局调用
    Vue.prototype.$msgBox = {
      alertMessageBox(options) {
        if (!alertMessage) {
          initInstance('alertMessage');
        }
        if (typeof options === 'object') {
          Object.assign(alertMessage, options);
          let a = alertMessage.$mount().$el;
          document.body.appendChild(a);
        }
        return new Promise((resolve, reject) =>{
          alertMessage.alertMessageBox()
            .then(val => {
              alertMessage = null;
              resolve(val);
            })
            .catch(err => {
              alertMessage = null;
              reject(err);
            });
        })
      },
      confirmMessageBox(options) {
        if (!confirmMessage) {
          initInstance('confirmMessage');
        }
        if (typeof options === 'object') {
          Object.assign(confirmMessage, options);
          let b = confirmMessage.$mount().$el;
          document.body.appendChild(b);
        }
        return new Promise((resolve, reject) =>{
          confirmMessage.confirmMessageBox()
          .then(val => {
            confirmMessage = null;
            resolve(val);
          })
          .catch(err => {
            confirmMessage = null;
            reject(err);
          });
        });
      },
      infoMessageBox(options) {
        if (!infoMessage) {
          initInstance('infoMessage');
        }
        if (typeof options === 'object') {
          Object.assign(infoMessage, options);
          let c = infoMessage.$mount().$el;
          document.body.appendChild(c);
        }
        return new Promise((resolve, reject) =>{
          infoMessage.infoMessageBox()
          .then(val => {
            infoMessage = null;
            resolve(val);
          })
          .catch(err => {
            infoMessage = null;
            reject(err);
          });
        });
      },
    };
};
export default MessageBox;